import i18next from "i18next";
import React from "react";
import { getI18n, useTranslation } from "react-i18next";
import { switchLocaleAction } from "../actions/switch-locale";
import { Config } from "../utils/config";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "./ui/dropdown-menu";

const isSelectedTypeNotInOrderingMethodData = (
  selectedType: string | null,
  orderingMethodData: { label: string; value: string }[]
): boolean => {
  if (selectedType) {
    return !orderingMethodData.some((method) => method.value === selectedType);
  }
  return false;
};

const Sidebar = ({
  id,
  authToken,
  setCurrentSelected,
  currentSelected,
  cartTotal,
  restaurantDetail,
  tableReservationCart,
  selectedType,
  setSelectedType,
}) => {
  const [isOpen, setOpen] = React.useState(false);
  const currentLanguage = getI18n();
  const { t } = useTranslation();
  const [isOrderingMethodOpen, setIsOrderingMethodOpen] = React.useState(
    selectedType === "" ? true : false
  );

  const [orderingMethodData, setOrderingMethodData] = React.useState<any>([]);
  const [isMethod, setIsMethod] = React.useState(
    selectedType === "dine_in" ||
      selectedType === "table_booking" ||
      selectedType === "table_reservation"
      ? false
      : true
  );

  React.useEffect(() => {
    setIsMethod(
      selectedType === "dine_in" ||
        selectedType === "table_booking" ||
        selectedType === "table_reservation"
        ? false
        : true
    );
  }, [selectedType]);

  React.useEffect(() => {
    setOrderingMethodData(
      Config.env.app.ordering_method_header.reduce((acc: any, item: any) => {
        if (
          (item.value === "table_reservation" &&
            !restaurantDetail.services.table_reservation) ||
          (item.value === "pickup" &&
            !restaurantDetail.services.pickup_service) ||
          (item.value === "delivery" &&
            !restaurantDetail.services.delivery_service) ||
          (item.value === "in_restaurant" &&
            (!restaurantDetail.services.table_reservation ||
              !restaurantDetail.tableReservation.allow_guest_pre_order)) ||
          item.value === "dine_in"
        ) {
          // Skip the item if the condition is not matched
          return acc;
        }
        return [...acc, item];
      }, [])
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restaurantDetail]);

  React.useEffect(() => {
    if (
      selectedType !== "dine_in" &&
      selectedType !== "table_booking" &&
      selectedType !== "table_reservation" &&
      orderingMethodData.length > 0
    ) {
      const result = isSelectedTypeNotInOrderingMethodData(
        selectedType,
        orderingMethodData
      );
      if (result === true) {
        setSelectedType("");
        const url = new URL(window.location.href);
        const params = url.searchParams;
        params.delete("type");

        window.history.pushState(null, "", url.toString());
        setIsOrderingMethodOpen(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderingMethodData, selectedType]);

  const handleChangeLanguage = async ({ value }) => {
    i18next.changeLanguage(value);
    await switchLocaleAction(value);
  };


  return (
    <aside className="max-sm:hidden flex-shrink-0 w-[128px] bg-white">
      <div className="sticky top-0 h-[100dvh] w-full pt-10 pb-6 px-2 flex flex-col items-center justify-between gap-4 md:ml-auto md:gap-2 lg:gap-4 overflow-y-auto">
        <nav className="w-full space-y-5">
          {/* <Sheet open={isOpen} onOpenChange={(isOpen) => setOpen(isOpen)}>
            <SheetTrigger asChild>
              <button className="size-10 mx-auto mb-8 flex items-center justify-center bg-green rounded-lg">
                <Menu className="size-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="left" className="">
              <nav className="space-y-6 text-left text-lg font-medium">
                <CardTitle
                  onClick={() => {
                    setCurrentSelected("menu");
                  }}
                  className="w-full cursor-pointer pl-4"
                >
                  {restaurantDetail?.name}
                </CardTitle>

                {Config.env.app.sidebar.map((item, index) => {
                  if (tableReservationCart && item.href === "menu") {
                    // If both conditions are true, do not render the item (return null)
                    return null;
                  }
                  return (
                    <Button
                      onClick={() => {
                        // Prevent navigation to "cart" if cartTotal is 0
                        // if (item.href === "cart" && cartTotal === 0) {
                        //   return;
                        // } else {
                        setCurrentSelected(item.href);
                        setOpen(false);
                        // }
                      }}
                      variant={"ghost"}
                      key={index}
                      className={`w-full text-left text-muted-foreground hover:text-foreground ${
                        currentSelected === item.href ? "text-foreground" : ""
                      }`}
                    >
                      <div className="w-full flex items-center gap-2">
                        {item.href === "cart" && cartTotal > 0 ? (
                          <React.Fragment>
                            <div className="relative">
                              <div className="absolute -top-2.5 -right-3 rounded-full text-center w-5 h-5  bg-muted z-0">
                                {cartTotal}
                              </div>
                              <item.icon />
                            </div>
                            {t(item.title)}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <item.icon /> {t(item.title)}
                          </React.Fragment>
                        )}
                      </div>
                    </Button>
                  );
                })}
                <div className="pl-2 w-full flex items-center gap-2">
                  <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                      <div className="w-full flex items-center gap-2">
                        <Button
                          variant="secondary"
                          size="icon"
                          className="rounded-full"
                        >
                          <img
                            src={
                              Config.env.app.languages.find(
                                (r) => r.value === currentLanguage.language
                              )?.image || Config.env.app.languages[0].image
                            }
                            height={20}
                            width={20}
                            alt={
                              Config.env.app.languages.find(
                                (r) => r.value === currentLanguage.language
                              )?.label || Config.env.app.languages[0].label
                            }
                          />
                        </Button>
                        <Label className="w-full text-left text-muted-foreground hover:text-foreground">
                          {t("languages.title")}
                        </Label>
                      </div>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent>
                      <DropdownMenuItem>
                        {t("languages.title")}
                      </DropdownMenuItem>
                      <DropdownMenuSeparator />
                      {Config.env.app.languages.map((item, index) => (
                        <DropdownMenuItem
                          className="flex gap-2"
                          key={index}
                          onClick={() => {
                            handleChangeLanguage({ value: item.value });
                          }}
                        >
                          <img
                            src={item.image}
                            height={20}
                            width={20}
                            alt={item.label}
                          />

                          {t(item.label)}
                        </DropdownMenuItem>
                      ))}
                    </DropdownMenuContent>
                  </DropdownMenu>
                </div>
              </nav>
            </SheetContent>
          </Sheet> */}

          {Config.env.app.aside.map((item, index) => {
            if (tableReservationCart && item.href === "menu") {
              return null;
            }
            return (
              <button
                key={index}
                className="w-full py-2 space-y-2"
                onClick={() => {
                  setCurrentSelected(item.href);
                }}
              >
                <span
                  className={` mx-auto flex items-center justify-center rounded-lg [&>svg]:size-5 ${
                    currentSelected === item.href
                      ? "size-9 text-white bg-red"
                      : "size-5 text-green-400"
                  }`}
                >
                  <item.icon />
                </span>
                <span
                  className={`text-base font-medium break-all ${
                    currentSelected === item.href
                      ? "text-red"
                      : "text-green-400"
                  }`}
                >
                  {t(`${item.title}`)}
                </span>
              </button>
            );
          })}
        </nav>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="space-y-2">
              <img
                className="size-5 mx-auto rounded-full"
                src={
                  Config.env.app.languages.find(
                    (r) => r.value === currentLanguage.language
                  )?.image || Config.env.app.languages[0].image
                }
                height={20}
                width={20}
                alt={
                  Config.env.app.languages.find(
                    (r) => r.value === currentLanguage.language
                  )?.label || Config.env.app.languages[0].label
                }
              />
              <p className="text-base font-medium">
                {t(
                  `${
                    Config.env.app.languages.find(
                      (r) => r.value === currentLanguage.language
                    )?.label || Config.env.app.languages[0].label
                  }`
                )}
              </p>
            </button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem>{t("languages.title")}</DropdownMenuItem>
            <DropdownMenuSeparator />
            {Config.env.app.languages.map((item, index) => (
              <DropdownMenuItem
                className="flex gap-2"
                key={index}
                onClick={() => {
                  handleChangeLanguage({ value: item.value });
                }}
              >
                <img src={item.image} height={20} width={20} alt={item.label} />

                {t(item.label)}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </aside>
  );
};

export default Sidebar;
